import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login/Login.vue'
import Register from '@/components/Login/Register.vue'
import User from '@/components/User.vue'
import Home from '@/components/Home.vue'
import SreenTime from '@/components/SreenTime.vue'
import AppsTime from '@/components/AppsTime.vue'
import WebsiteFilter from '@/components/WebsiteFilter.vue'
import Geofences from '@/components/Geofences.vue'
import GeofencesAdd from '@/components/GeofencesAdd.vue'
import Notifications from '@/components/Notifications.vue'
import My from '@/components/My.vue'
import Buy from '@/components/Buy.vue'
import About from '@/components/About.vue'
import BrowserHistroy from '@/components/BrowserHistroy.vue'
import AddException from '@/components/AddException.vue'
import Refresh from '@/components/Refresh.vue'
import config from '../../static/config.json'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: config.IS_DEMO ? 'User' : 'Login',
      component: config.IS_DEMO ? User : Login
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/User/:userid/:device?',
      name: 'User',
      component: User,
      props: true,
      children: [
        // { path: '', component: Home, props: true },
        { path: 'Home', name: 'Home', component: Home },
        { path: 'SreenTime', name: 'SreenTime', component: SreenTime },
        { path: 'AppsTime', name: 'AppsTime', component: AppsTime },
        { path: 'WebsiteFilter', name: 'WebsiteFilter', component: WebsiteFilter },
        { path: 'Geofences', name: 'Geofences', component: Geofences },
        { path: 'GeofencesAdd', name: 'GeofencesAdd', component: GeofencesAdd },
        { path: 'Notifications', name: 'Notifications', component: Notifications },
        { path: 'My', name: 'My', component: My, props: true },
        { path: 'Buy', name: 'Buy', component: Buy },
        { path: 'About', name: 'About', component: About },
        { path: 'BrowserHistroy', name: 'BrowserHistroy', component: BrowserHistroy },
        { path: 'AddException', name: 'AddException', component: AddException },
        { path: 'Refresh', name: 'Refresh', component: Refresh }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js